import CSVToArray from './data/csvtoarray/CSVToArray.js';
export default CSVToArray;